import { Box } from "@mui/system";
import { useCallback } from "react";
import { ErrorBoundary, useUserContext } from "@WahooFitness/wahoo-offline-mfe";
import AthleteOnboarding from "./AthleteOnboarding";
import { Container } from "@mui/material";

const AthleteOnboardingContainer = () => {
  const { currentUser, userIsLoading, userError, mutateUser } = useUserContext();
  const handleReload = useCallback(() => {
    mutateUser();
  }, [mutateUser]);

  return (
    // wf-self-scrolling-page suppresses the shell's page-end spacer: this page fills
    // the scrollport and handles its own bottom clearance via the sticky action bar,
    // so the spacer would only add empty scrollable space below it.
    <Container
      className="wf-self-scrolling-page"
      maxWidth="sm"
      disableGutters
      sx={{ minHeight: "100%", display: "flex", flexDirection: "column" }}
    >
      <ErrorBoundary error={userError} isLoading={userIsLoading} onReload={handleReload}>
        {/* Grows instead of height="100%": the container only has a min-height, so a
            percentage height would resolve to auto and collapse the flex chain that
            pins the Continue button to the bottom. */}
        <Box display="flex" flexDirection="column" width="100%" flexGrow={1}>
          {currentUser && <AthleteOnboarding user={currentUser} />}
        </Box>
      </ErrorBoundary>
    </Container>
  );
};

export default AthleteOnboardingContainer;
